"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PixelMap = void 0;
class PixelMap {
    static *itemsIn(pixelMap) {
        for (let y in pixelMap) {
            const row = pixelMap[y].split('');
            for (let x in row) {
                yield {
                    x: parseInt(x),
                    y: parseInt(y),
                    data: row[x]
                };
            }
        }
    }
}
exports.PixelMap = PixelMap;
//# sourceMappingURL=PixelMap.js.map